/**
 * Admin roles exactly as they arrive in the JWT `role` claim (the serialized
 * `SportBooking.Domain.Enums.AdminRole` name). Compared as strings all over the app — these
 * constants exist so a rename on the server breaks one file instead of six.
 */
export const AdminRoles = {
  Staff: 'Staff',
  Manager: 'Manager',
  Owner: 'Owner',
  SuperAdmin: 'SuperAdmin',
} as const;

export type AdminRoleName = (typeof AdminRoles)[keyof typeof AdminRoles];

